<template>
  <div>
    <h4 class="text-center text-lighter font-weight-normal mt-5 mb-0">Login to Shared Intranet Account</h4>
    <form class="my-5">
      <b-form-group class="mb-0" v-if="errors.common">
        <p class="text-danger">{{ errors.common }}</p>
      </b-form-group>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { setLastSignIntranet } from '@/views/auth/utils'
import redirectAfterLogin from '@/mixins/redirectAfterLogin'

export default {
  name: 'loginIntranet',
  mixins: [redirectAfterLogin],
  data: () => ({
    errors: {}
  }),
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters(['frontDomain'])
  },
  mounted() {
    this.login()
  },
  methods: {
    ...mapActions('auth', ['loginIntranet']),
    getEndpoint() {
      const loginEndpoint = this.$route.query.endpoint
      try {
        const url = new URL(loginEndpoint)
        url.searchParams.set('t', Date.now().toString())
        return url.toString()
      } catch (e) {
        return null
      }
    },
    login() {
      setLastSignIntranet(false)
      const endpoint = this.getEndpoint()
      if (!endpoint) {
        Vue.set(this.errors, 'common', "Can't determine intranet login endpoint!")
        return
      }
      this.loginIntranet(endpoint).then(() => {
          setLastSignIntranet(true)
          this.redirectAfterLogin()
        }, (error) => {
          if (error.response && error.response.data) {
            let data = error.response.data
            let message = ''
            for (let field in data.errors) {
              message += data.errors[field].join(' ')
            }
            Vue.set(this.errors, 'common', message)
          } else {
            throw error
          }
        })
    },
    getError(field) {
      return this.errors[field]
    }
  }
}
</script>

<style lang="scss">
.ms-login-button {
  display: flex;
  align-items: center;
  height: 41px;
  padding: 0 12px;
  border-radius: 0;
  border: 1px solid #8c8c8c;
  background: #fff;
  color: #5e5e5e;
  font-family: 'Segoe UI';
  font-size: 15px;
  margin: 0 auto 20px;
  white-space: nowrap;

  & > svg {
    margin-right: 12px;
  }
}
</style>
